import { Pipe, PipeTransform } from '@angular/core';
import { toTitleCaseSmart } from 'src/app/shared/utils/titleCase';

@Pipe({
  name: 'titleCaseSmart',
  standalone: true
})
export class TitleCaseSmartPipe implements PipeTransform {
  transform(value: string): string {
    return toTitleCaseSmart(value);
  }
}